import {
    FETCH_CORE_AREAS,
    FETCH_CORE_CLIENTS,
    FETCH_CORE_CONTACTS,
    FETCH_CORE_EQUIPMENT,
    FETCH_CORE_SITES,
    FETCH_CORE_SYSTEMS,
    FETCH_SYSTEMS_BY_SITE,
    SET_CORE_CLIENT,
    SET_CORE_EQUIPMENT,
    SET_CORE_SITE,
    SET_CORE_SYSTEM
} from '../actions/actionTypes';

const initialState = {
    areas:             [],
    clients:           [],
    clientsMeta:       {},
    contacts:          [],
    equipment:         [],
    equipmentMeta:     {},
    selectedClient:    {},
    selectedEquipment: {},
    selectedSite:      {},
    selectedSystem:    {},
    sites:             [],
    sitesMeta:         {},
    siteSystems:       [],
    systems:           [],
    systemsMeta:       {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CORE_AREAS:
            return {
                ...state,
                areas: [...action.payload]
            };
        case FETCH_CORE_CLIENTS:
            return {
                ...state,
                clients:     [ ...action.payload.data ],
                clientsMeta: { ...action.payload.meta }
            };
        case FETCH_CORE_CONTACTS:
            return {
                ...state,
                contacts: [...action.payload]
            };
        case FETCH_CORE_EQUIPMENT:
            return {
                ...state,
                equipment:     [...action.payload.data],
                equipmentMeta: {...action.payload.meta}
            };
        case FETCH_CORE_SITES:
            return {
                ...state,
                sites:     [ ...action.payload.data ],
                sitesMeta: { ...action.payload.meta }
            };
        case FETCH_CORE_SYSTEMS:
            return {
                ...state,
                systems:     [...action.payload.data],
                systemsMeta: {...action.payload.meta}
            };
        case FETCH_SYSTEMS_BY_SITE:
            return {
                ...state,
                siteSystems: [...action.payload]
            };
        case SET_CORE_CLIENT:
            return {
                ...state,
                selectedClient: { ...action.payload }
            };
        case SET_CORE_EQUIPMENT:
            return {
                ...state,
                selectedEquipment: { ...action.payload }
            };
        case SET_CORE_SITE:
            return {
                ...state,
                selectedSite: { ...action.payload }
            };
        case SET_CORE_SYSTEM:
            return {
                ...state,
                selectedSystem: { ...action.payload }
            };
        default:
            return state;
    }
};
